import { useContext } from 'react'

import { AuthContext } from 'features/auth'
import { useProjectStore } from 'features/project/store'
import {
  ClientAuthRole,
  getEffectiveRole,
  isRoleAllowed,
} from 'src/types/auth-role'
import type { ProjectState } from 'types/project'

export const useCanAccess = (policy: ClientAuthRole[]): boolean => {
  const { userDetails } = useContext(AuthContext)
  const details = useProjectStore((s: ProjectState) => s.details)
  const effective = getEffectiveRole(
    details?.role,
    !!userDetails?.yogi_user,
    userDetails?.role,
  )
  return isRoleAllowed(effective, policy)
}
